import { useState, useRef, createContext, useEffect, useContext } from "react";

const OrganizationsPickerContext = createContext({
	filteredList: "",
	setFilteredList: () => {},
	filterType: "",
	setFilterType: () => {},
	selectedEntity: "",
	setSelectedEntity: () => {},
	organizations: [],
	searchInput: "",
});

export function OrganizationsPickerContextProvider({
	children,
	organizations = [],
	types = [],
	resellers,
}) {
	const [filteredList, setFilteredList] = useState(organizations);

	const [filterType, setFilterType] = useState([]);

	const [filterResellers, setFilterResellers] = useState([]);

	const [selectedEntity, setSelectedEntity] = useState([]);

	const searchInput = useRef();

	useEffect(() => {
		setFilteredList(organizations);
	}, [organizations]);

	const context = {
		filteredList,
		setFilteredList,
		filterType,
		setFilterType,
		filterResellers,
		setFilterResellers,
		selectedEntity,
		setSelectedEntity,
		searchInput,
		organizations,
		types,
		resellers,
	};

	return (
		<OrganizationsPickerContext.Provider value={context}>
			{children}
		</OrganizationsPickerContext.Provider>
	);
}

export const useOrganizationPicker = () => {
	const context = useContext(OrganizationsPickerContext);
	if (context === undefined) {
		throw new Error(
			"useOrganizationPicker must be used within a OrganizationsPickerContextProvider"
		);
	}
	return context;
};

export default OrganizationsPickerContext;
